import React from "react";
import { configure } from "mobx";
import { Provider } from "mobx-react";
import "mobx-react/batchingForReactDom";

configure({ enforceActions: "observed" });

const withProvider = store => Component => props => (
  <Provider store={store}>
    <Component {...props} />
  </Provider>
);

export default withProvider;
